import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { DEPARTMENTS } from "@/data/site";
import { IDF_MAP } from "@/data/idfMap";

// Carte géographique réelle de l'Île-de-France (contours officiels des départements).
const slugByCode = DEPARTMENTS.reduce((acc, d) => {
  acc[d.code] = d;
  return acc;
}, {});

export default function IleDeFranceMap() {
  const [hover, setHover] = useState(null);
  const navigate = useNavigate();
  const hovered = hover ? slugByCode[hover] : null;

  return (
    <div className="relative w-full">
      <svg
        viewBox={IDF_MAP.viewBox}
        className="w-full h-auto drop-shadow-[0_20px_40px_rgba(0,0,0,0.35)]"
        role="img"
        aria-label="Carte de l'Île-de-France - départements desservis"
      >
        <defs>
          <filter id="idf-shadow" x="-20%" y="-20%" width="140%" height="140%">
            <feDropShadow dx="0" dy="0.6" stdDeviation="0.6" floodColor="#009CFF" floodOpacity="0.5" />
          </filter>
        </defs>

        {[...IDF_MAP.depts]
          .sort((a, b) => (a.id === hover ? 1 : 0) - (b.id === hover ? 1 : 0))
          .map((d) => {
            const dept = slugByCode[d.id];
            if (!dept) return null;
            const active = hover === d.id;
            const isParis = d.id === "75";
            return (
              <path
                key={d.id}
                d={d.path}
                data-testid={`map-dept-${d.id}`}
                onMouseEnter={() => setHover(d.id)}
                onMouseLeave={() => setHover(null)}
                onClick={() => navigate(`/zone-intervention/${dept.slug}`)}
                className="cursor-pointer"
                fill={active ? "#009CFF" : isParis ? "rgba(0,156,255,0.45)" : "rgba(255,255,255,0.07)"}
                stroke={active ? "#ffffff" : "rgba(0,156,255,0.6)"}
                strokeWidth={active ? 0.7 : 0.4}
                strokeLinejoin="round"
                style={{
                  transition: "fill 0.25s ease, stroke 0.2s ease, transform 0.35s cubic-bezier(0.22,1,0.36,1)",
                  transformBox: "fill-box",
                  transformOrigin: "center",
                  transform: active ? "scale(1.09)" : "scale(1)",
                  filter: active ? "url(#idf-shadow)" : "none",
                }}
              />
            );
          })}

        {/* Codes départements */}
        {IDF_MAP.depts.map((d) => {
          const active = hover === d.id;
          return (
            <text
              key={`t-${d.id}`}
              x={d.cx}
              y={d.cy}
              textAnchor="middle"
              dominantBaseline="central"
              className="pointer-events-none select-none"
              fontSize={d.id === "75" || ["92", "93", "94"].includes(d.id) ? 3 : 4.2}
              fontWeight="800"
              fill="#ffffff"
              style={{ paintOrder: "stroke", stroke: "rgba(13,27,42,0.55)", strokeWidth: active ? 0 : 0.6 }}
            >
              {d.id}
            </text>
          );
        })}
      </svg>

      <div className="mt-4 h-6 text-center">
        {hovered ? (
          <p data-testid="map-tooltip" className="text-sm font-semibold text-aqua">
            {hovered.name} ({hovered.code}) — cliquez pour découvrir notre intervention
          </p>
        ) : (
          <p className="text-sm text-white/50">Survolez un département pour l'explorer</p>
        )}
      </div>
    </div>
  );
}
